import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ascendLogo from "../../../assets/ACS-Images/Ascend-Logo.png";
import OnboardingImg from "../../../assets/ACS-Images/Onboarding_Img.jpg";
import TestimonialImg from "../../../assets/ACS-Images/logistics-testimonial.png";

const FinalOnboarding = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-screen bg-white grid grid-cols-1 md:grid-cols-12">
      {/* Left Picture (25%) */}
      <div
        className="hidden md:block md:col-span-2 h-screen bg-cover bg-center sticky top-0"
        style={{ backgroundImage: `url(${OnboardingImg})` }}
        aria-hidden="true"
      />

      {/* Center Content (50%) */}
      <div className="md:col-span-8 min-h-screen flex items-start md:items-center justify-center py-8 md:py-12">
        <div className="w-full max-w-7xl px-4 md:px-10 py-4 md:py-10">
          {/* Logo */}
          <div className="flex flex-col items-center">
            <img
              src={ascendLogo}
              alt="Ascend Logo"
              className="w-32 md:w-40 mb-6 hover:scale-105 transition-transform duration-300"
            />

            {/* Stepper */}
            <div className="flex items-center justify-center gap-6 mt-2 mb-6">
              {["About yourself", "Company Information", "Invite your team"].map((label, idx) => (
                <React.Fragment key={idx}>
                  {idx > 0 && <div className="w-8 border-t-2 border-gray-300" />}
                  <div className="flex flex-col items-center">
                    <div className="w-8 h-8 rounded-full border-2 border-[#223688] bg-[#223688] text-white font-semibold flex items-center justify-center">
                      {idx + 1}
                    </div>
                    <span className="mt-1 text-sm font-semibold text-black text-center">
                      {label}
                    </span>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* Thank You Message */}
          <div className="text-center max-w-xl mx-auto">
            <h1 className="text-fluid-xl font-bold mb-4">Thank you for your submission!</h1>
            <p className="text-fluid-base text-gray-600">
              We are currently reviewing your submission and will get back to you within 1–2 business days about next steps.
            </p>
          </div>

          {/* Actions */}
          <div className="flex flex-col items-center gap-4 mt-10">
            <button
              onClick={() => navigate("/login")}
              className="px-10 py-2 bg-[#223688] text-white rounded-full hover:bg-[#1c2c6d] transition"
            >
              Go to login page
            </button>
          </div>
        </div>
      </div>

      {/* Right Picture (25%) */}
      <div
        className="hidden md:block md:col-span-2 h-screen bg-cover bg-center sticky top-0"
        style={{ backgroundImage: `url(${OnboardingImg})` }}
        aria-hidden="true"
      />
    </div>
  );
};

export default FinalOnboarding;
